import React, { FC, useEffect, useState } from 'react';
import { Button, Input } from '../../../../components';
import { BankAccount } from 'interfaces';
import { Spin } from 'antd';
import { BsChevronDown } from 'react-icons/bs';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { CardNumberSelectionModal } from '../../cardNumberSelectionModal/cardNumberSelectionModal.index';
import { deposit, getCardNumbers } from 'services';
import { deleteCommaSeparator, detectBank, faNumToEnNum, formatCardNumber, plainNumber, priceDigit } from 'scripts';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export const BuyPaymentDirectMethod: FC = () => {
    const [cardNumbersLoading, setCardNumbersLoading] = useState(true);
    const [cardNumbers, setCardNumbers] = useState<Omit<BankAccount, 'iBan'>[]>();
    const [selectedCardNumber, setSelectedCardNumber] = useState<Omit<BankAccount, 'iBan'>>();
    const [amount, setAmount] = useState<number>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [navigateLoading, setNavigateLoading] = useState(false);

    const onCardNumberSelection = (cardNumber: Omit<BankAccount, 'iBan'>) => {
        setSelectedCardNumber(cardNumber);
        setModalOpen(false);
    };

    const onGatewayDeposit = () => {
        if (amount && selectedCardNumber) {
            const formData = new FormData();
            formData.append('Amount', amount?.toString());
            formData.append('CardNumberId', selectedCardNumber?.id);

            const onComplete = (trackingCode: string, paymenturl: string) => {
                setNavigateLoading(true);
                toast.info('در حال انتقال به درگاه پرداخت...', { autoClose: 2000 });
                setTimeout(() => {
                    window.location.replace(paymenturl);
                }, 2000);
            };

            deposit(setLoading, formData, onComplete);
        }
    };

    useEffect(() => {
        getCardNumbers(setCardNumbersLoading, setCardNumbers, setSelectedCardNumber);
    }, []);

    return (
        <div className={'flex flex-col'}>
            {cardNumbers && (
                <CardNumberSelectionModal
                    open={modalOpen}
                    setOpen={setModalOpen}
                    cardNumbers={cardNumbers}
                    onSelect={onCardNumberSelection}
                />
            )}
            <label className={'max-lg:text-sm'}>شماره کارت:</label>
            <Spin spinning={cardNumbersLoading}>
                <div
                    onClick={() => setModalOpen(true)}
                    className={
                        'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 max-lg:h-12 max-lg:text-sm mt-2 clickable'
                    }
                >
                    {selectedCardNumber && (
                        <>
                            <div className={'flex items-center gap-4'}>
                                <img
                                    src={detectBank(selectedCardNumber?.cardNumber)?.bank_logo}
                                    className={'w-6 h-6'}
                                />
                                {selectedCardNumber?.bank?.name}
                            </div>
                            {formatCardNumber(selectedCardNumber?.cardNumber)}
                            <BsChevronDown />
                        </>
                    )}
                </div>
            </Spin>
            <label className={'mt-4 max-lg:text-sm'}>مبلغ واریزی‌ (تومان):</label>
            <Input
                placeholder={'مبلغ واریزی را وارد نمایید...'}
                className={'mt-2'}
                inputMode={'numeric'}
                type={'text'}
                value={priceDigit(amount, '،')}
                onChange={(e) => setAmount(Number(plainNumber(e.target.value.replace(/[^۰-۹0-9,.]/g, ''))))}
                suffix={<CoinIcon symbol={'IRT'} className={'mr-2'} />}
                dir={amount || amount === 0 ? 'ltr' : 'rtl'}
            />
            <Button
                type={'primary'}
                className={'mt-6'}
                onClick={onGatewayDeposit}
                loading={loading || navigateLoading}
                disabled={loading || navigateLoading || !amount || !selectedCardNumber}
            >
                پرداخت
            </Button>
        </div>
    );
};
